type Props = {
  fill: string;
  height: string;
  width: string;
};

const TickIcon = ({ height, width, fill }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.8315 1.88958C6.94512 1.49463 5.95482 1.39679 5.00829 1.61064C4.06175 1.8245 3.20971 2.3386 2.57923 3.07626C1.94874 3.81392 1.5736 4.73563 1.50976 5.70392C1.44591 6.67221 1.69677 7.63519 2.22493 8.44926C2.7531 9.26332 3.53026 9.88485 4.44051 10.2211C5.35077 10.5574 6.34534 10.5905 7.27591 10.3153C8.20648 10.0402 9.02318 9.47161 9.6042 8.6944C10.1852 7.91718 10.4994 6.97297 10.5 6.00258V5.54286C10.5 5.26672 10.7239 5.04286 11 5.04286C11.2761 5.04286 11.5 5.26672 11.5 5.54286V6.00286C11.4993 7.18889 11.1153 8.34322 10.4051 9.29315C9.69499 10.2431 8.69681 10.938 7.55945 11.2743C6.42209 11.6106 5.20649 11.5702 4.09396 11.1592C2.98142 10.7481 2.03156 9.9885 1.38603 8.99354C0.740496 7.99857 0.433885 6.82158 0.511922 5.63812C0.589959 4.45466 1.04846 3.32813 1.81905 2.42654C2.58964 1.52495 3.63103 0.896608 4.7879 0.635228C5.94478 0.373848 7.15515 0.493433 8.2385 0.976148C8.49074 1.08854 8.60411 1.38413 8.49172 1.63636C8.37933 1.8886 8.08374 2.00197 7.8315 1.88958Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3536 2.14645C11.5488 2.34171 11.5488 2.65829 11.3536 2.85355L6.35355 7.85355C6.15836 8.04875 5.84191 8.04883 5.64662 7.85373L4.14662 6.35523C3.95126 6.16006 3.95111 5.84348 4.14627 5.64812C4.34143 5.45276 4.65802 5.4526 4.85338 5.64777L5.99982 6.79307L10.6464 2.14645C10.8417 1.95118 11.1583 1.95118 11.3536 2.14645Z"
        fill={fill}
      />
    </svg>
  );
};

export default TickIcon;
